import { Card, CardBody } from "@nextui-org/react";
import { TrendingDown, TrendingUp } from "lucide-react";
import { ZTooltip } from "@/shared/components/ZTooltip/ZTooltip";

interface StatsCardProps {
  label: string;
  value: number | string;
  trend?: {
    direction: "up" | "down";
    value: number;
  };
}

export function StatsCard({ label, value, trend }: StatsCardProps) {
  return (
    <Card className="shadow-none border border-[#E4E4E7] rounded-lg">
      <CardBody className="p-4">
        <div className="text-xs text-[#71717A] mb-2">{label}</div>
        <div className="flex items-center gap-2">
          <div className="text-lg font-medium leading-7 text-[#171717]">{value}</div>
          {trend && (
            <ZTooltip
              content="from last month"
              placement="top"
              isDisabled={false}
              showArrow
            >
              <div
                className={`flex items-center gap-1 px-1.5 py-0.5 rounded ${
                  trend.direction === "up" ? "bg-[#DCFCE7]" : "bg-[#FEE2E2]"
                }`}
              >
                {trend.direction === "up" ? (
                  <TrendingUp size={12} className="text-[#16A34A]" />
                ) : (
                  <TrendingDown size={12} className="text-[#DC2626]" />
                )}
                <span
                  className={`text-xs font-medium ${
                    trend.direction === "up" ? "text-[#16A34A]" : "text-[#DC2626]"
                  }`}
                >
                  {trend.value}
                </span>
              </div>
            </ZTooltip>
          )}
        </div>
      </CardBody>
    </Card>
  );
}
